// extracted by mini-css-extract-plugin
export default {"button":"ButtonDefault_button__sM16D","animation":"ButtonDefault_animation__yD6Ts","backgroundColor":"ButtonDefault_backgroundColor__WTfJt"};